"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GENERAL = void 0;
var GENERAL = {
  INPUT__FILTER_SEARCH: 'ordersFilters-input-search',
  BUTTON__ADD_NEW_ORDER: 'orders-button-addNewOrder',
  BUTTON__EXPORT_ORDERS: 'orders-div-exportOrders',
  BUTTON__FILTERS: 'orders-div-filters',
  BUTTON__FILTER_DELIVERY_DATE: 'ordersFilters-button-deliveryDate',
  BUTTON__EDIT_INVENTORY_MANAGEMENT_CONFIRM: 'editInventoryManagementModal-button-confirm'
};
exports.GENERAL = GENERAL;